import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
    {
        path: 'project',
        loadChildren: () => import('./project/project.routes').then(r => r.PROJECT_ROUTES)
    },
    {
        path: 'release-info',
        loadChildren: () => import('./release-info/release-info.routes').then(r => r.RELEASE_INFO_ROUTES)
    },
    {
        path: 'certificate',
        loadChildren: () => import('./certificate/certificate.routes').then(r => r.CERTIFICATE_ROUTES)
    },
    {
        path: 'home-inspection-certificate',
        loadChildren: () => import('./home-inspection-certificate/homeinspection-certificate.routes').then(r => r.HOME_INSPECTION_CERTIFICATE_ROUTES)
    },
    {
        path: 'user',
        loadChildren: () => import('./login/login.routes').then(r => r.LOGIN_ROUTES)
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.routes').then(r => r.DASHBOARD_ROUTES)
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then(r => r.ADMIN_ROUTES)
    },
    {
        path: 'prometric',
        loadChildren: () => import('./prometric/prometric.routes').then(r => r.PROMETRIC_ROUTES)
    },
    {
        path: 'styleguide',
        loadChildren: () => import('./styleguide/styleguide.routes').then(r => r.STYLEGUIDE_ROUTES)
    },
    {
        path: 'ifc/learn',
        loadChildren: () => import('./hubblestudio/hubblestudio.routes').then(r => r.HUBBLESTUDIO_ROUTES)
    },
    {
        path: 'operationalCertificate',
        loadChildren: () => import('./operational-certificate/operational-certificate.routes').then(r => r.OPERATIONAL_CERTIFICATE_ROUTES)
    },
    {
        path: 'projectStudy',
        loadChildren: () => import('./project-study/project-study.routes').then(r => r.PROJECT_STUDY_ROUTES)
    },
    {
        path: 'project-studies',
        loadChildren: () => import('./project-study-publish/project-study-publish.routes').then(r => r.PROJECT_STUDY_PUBLISH_ROUTES)
    },
    {
        path: 'organization',
        loadChildren: () => import('./organization/organization.routes').then(r => r.ORGANIZATION_ROUTES)
    },
    {
        path: 'database-admin',
        loadChildren: () => import('./database-admin/database-admin.routes').then(r => r.DATABASE_ADMIN_ROUTES)
    },
    {
        path: 'edge-experts',
        loadChildren: () => import('./edge-experts/edge-experts.routes').then(r => r.EDGE_EXPERTS_ROUTES)
    },
    {
        path: 'prometricParticipationAgreement/:email',
        pathMatch: 'prefix',
        redirectTo: 'prometric/candidate-agreement/:email'
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'user/login'
    },
    {
        path: '**',
        redirectTo: 'user/login'
    }
];
